import { isPlainObject } from 'lodash-es';

export function createEpicsService(epicsList = []) {
  return $injector => {
    'ngInject';

    const initedEpics = epicsList.map(epic => {
      // Ensure DI works even after being mangled
      $injector.annotate(epic);
      // Allow the epics to be injectable
      return $injector.invoke(epic);
    });

    return store => next => action => {
      const ret = next(action);
      // Only apply epics if it's a normal action and not a thunk, promise, etc.
      if (isPlainObject(action)) {
        initedEpics.forEach(epic => epic(action, store));
      }
      return ret;
    };
  };
}
